import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { AxiosError } from 'axios';
import { CustomWorksheetTemplate, CWTBehaviourEnum, CWTSchema, CWTTypeEnum } from '../types/custom-worksheet-v2';
import queryClient from '../query-client';
import { EntityTypeEnum } from '../types/entity';

export type CreateCWTRequest = {
    name: string;
    description?: string | null;
    tags: string[];
    schema?: CWTSchema;
    status?: 'PUBLISHED' | 'UNPUBLISHED';
    entityTypes?: EntityTypeEnum[];
    allowAsSchedule: boolean;
    behaviour: CWTBehaviourEnum | null;
};

async function createCustomWorksheetTemplate(req: CreateCWTRequest): Promise<{ template: CustomWorksheetTemplate }> {
    const { data } = await api.post(`/templates/custom-worksheets`, req);
    return data;
}

export function useCreateCustomWorksheetTemplate(): UseMutationResult<
    { template: CustomWorksheetTemplate },
    AxiosError,
    CreateCWTRequest,
    unknown
> {
    return useMutation((req) => createCustomWorksheetTemplate(req), {
        onSettled: () => {
            queryClient.invalidateQueries(['custom-worksheet-templates']);
        },
    });
}
